import axios from '@/axios'

export default {
	state: {
		messages: [],
		support: {},
	},
	mutations: {
		setSupport(state, support) {
			state.support = support
		},
		setMessages(state, messages) {
			state.messages = messages;
		}
	},
	actions: {
		async getSupport({commit}, id) {
			try {
				let res = await axios.get('/support/view/' + id)
				commit('setSupport', res.data.data);
			} catch (e) {
				this.$vs.notify({
					title: 'Error',
					text: e.message,
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'danger'
				})
			}
		},
		async getMessagesSupport({commit}, layout) {
			try {
				let res = await axios.get('/support')
				commit('setMessages', res.data.data)
			} catch (e) {
				this.$vs.notify({
					title: 'Error',
					text: e.message,
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'danger'
				})
			}
		}
	},
}
